import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=298f757d&scoped=true"
import script from "./AreaSelect.vue?vue&type=script&lang=js"
export * from "./AreaSelect.vue?vue&type=script&lang=js"
import style0 from "./AreaSelect.vue?vue&type=style&index=0&id=298f757d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f757d",
  null
  
)

export default component.exports